import { useMutation } from 'react-query';
import { network } from 'services/network';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import qs from 'qs';

const mutationFn = (params: QueryParams) => {
    const querystring = qs.stringify(params.querystring, { addQueryPrefix: true, skipNulls: true });
    return network.post(`api/bo/saveFilterBulkAssignTags${querystring}`, params.body).then((response) => {
        return response.data;
    });
};

export const useMutationSaveFilterBulkAssignTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    body: {
        bulkAssigneeToUserUniqIdNotification: number;
        bulkAssignee: number;
        filter: {
            filters: IFilter;
        };
        paging: {
            page: number;
            size: number;
        };
        withDetails: boolean;
    };
    querystring: {
        lastRunActivities: number;
    };
}
